import { makeAutoObservable } from 'mobx'

class ErrorStore {
  snackbar = {
    open: false,
    message: '',
    severity: 'info', // 'success', 'error', 'warning', 'info'
  }

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true })
  }

  _show(message, severity) {
    this.snackbar = { open: true, message, severity }
  }

  showError(message) {
    this._show(message, 'error')
  }

  showSuccess(message) {
    this._show(message, 'success')
  }

  showWarning(message) {
    this._show(message, 'warning')
  }

  showInfo(message) {
    this._show(message, 'info')
  }

  closeSnackbar() {
    this.snackbar.open = false
  }
}

export default ErrorStore
